<template>
    <div >
           <app-line v-for="line in label.lines" v-show="!parseInt(line.masterBlock) && !parseInt(line.copy.length)" :line="line" :label="label"> </app-line>
         <div v-if="this.label.allow_fontcolors" class="colorTextContainer">
            <app-colortext :colors="label.textcolors" :label="label"></app-colortext>
        </div>
     </div>
</template>

<script>
    import Line from './Line';
 import ColorText from './ColorText/Color';

    export default {
        props      : ['label'],
        components : {
            appLine : Line,
            appColortext :ColorText
        }
    }
</script>
<style>
    .colorTextContainer{
        display: none;
    }

    .previewLineContainer.masterBlock.visible{
        display:table !important;
    }


</style>



// WEBPACK FOOTER //
// src/components/Lines.vue